import { render, staticRenderFns } from "./su-details.vue?vue&type=template&id=0063aeb1&scoped=true"
import script from "./su-details.vue?vue&type=script&lang=js"
export * from "./su-details.vue?vue&type=script&lang=js"
import style0 from "./su-details.vue?vue&type=style&index=0&id=0063aeb1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0063aeb1",
  null
  
)

export default component.exports